import LandingImageCtaPage from '../../../components/landing/LandingImageCtaPage';

export default function AppThemeTestA() {
  const PAGE_NAME = 'APP_THEME_TEST_A';
  const BUTTON_LABEL = '지금 당장 잠들러 가기';
  const TEST_AUDIO_SRC = 'https://dqijsv4cxvpeb.cloudfront.net/sounds/9bb43611-2544-41f1-bd8f-9f97089447e2.mpga';

  return (
    <LandingImageCtaPage
      pageName={PAGE_NAME}
      buttonLabel={BUTTON_LABEL}
      imageSrc="/landing/A.jpg"
      imageAlt="상세페이지 이미지"
      backgroundAudioSrc={TEST_AUDIO_SRC}
      audioTitle="Audio"
      autoPlayAudio
    />
  );
}
